import cars_model from '../views/cars_model/index.vue'
import cars_model_create from '../views/cars_model/create.vue'
import cars_model_edit from '../views/cars_model/edit.vue'
import cars_model_detail from '../views/cars_model/detail.vue'
import cars_model_import from '../views/cars_model/import.vue'

const routes = [
  {
    path: "/cars_model",
    name: "cars_model",
    component: cars_model,
    meta: { authOnly: true },
  },
  {
    path: "/cars_model/create",
    name: "cars_model_create",
    component: cars_model_create,
    meta: { authOnly: true },
  },
  {
    path: "/cars_model/edit/:uuid",
    name: "cars_model_edit",
    component: cars_model_edit,
    meta: { authOnly: true },
  },
  {
    path: "/cars_model/detail/:uuid",
    name: "cars_model_detail",
    component: cars_model_detail,
    meta: { authOnly: true },
  },
  {
    path: "/cars_model/import",
    name: "cars_model_import",
    component: cars_model_import,
    meta: { authOnly: true },
  }]

export default routes
